class AdHocFiltersVariableUrlSyncHandler {
  constructor(_variable) {
    this._variable = _variable;
  }
  getKey() {
    return `var-${this._variable.state.name}`;
  }
  getKeys() {
    return [this.getKey()];
  }
  getUrlState() {
    const filters = this._variable.state.filters;
    if (filters.length === 0) {
      return { [this.getKey()]: [""] };
    }
    const value = filters.map((filter) => toArray(filter).map(escapeDelimiter).join("|"));
    return { [this.getKey()]: value };
  }
  updateFromUrl(values) {
    const urlValue = values[this.getKey()];
    if (urlValue == null) {
      return;
    }
    const filters = deserializeUrlToFilters(urlValue);
    this._variable.setState({ filters });
  }
}
function deserializeUrlToFilters(value) {
  if (Array.isArray(value)) {
    const values = value;
    return values.map(toFilter).filter(isFilter);
  }
  const filter = toFilter(value);
  return filter === null ? [] : [filter];
}
function escapeDelimiter(value) {
  if (value === null || value === void 0) {
    return "";
  }
  return /\|/g[Symbol.replace](value, "__gfp__");
}
function unescapeDelimiter(value) {
  if (value === null || value === void 0) {
    return "";
  }
  return /__gfp__/g[Symbol.replace](value, "|");
}
function toArray(filter) {
  return [filter.key, filter.operator, filter.value];
}
function toFilter(value) {
  if (typeof value !== "string" || value.length === 0) {
    return null;
  }
  const parts = value.split("|").map(unescapeDelimiter);
  return {
    key: parts[0],
    operator: parts[1],
    value: parts[2],
    condition: ""
  };
}
function isFilter(filter) {
  return filter !== null && typeof filter.key === "string" && typeof filter.value === "string";
}

export { AdHocFiltersVariableUrlSyncHandler };
//# sourceMappingURL=AdHocFiltersVariableUrlSyncHandler.js.map
